import React from 'react';
// import logo from '../../../assets/img/logo/logo-pay42.png';
// import logoIpague from '../../../assets/img/logo/ipague.png';

import '../../../assets/scss/components/app-loader.scss';
class SpinnerComponent extends React.Component {
  render() {
    return (
      <div className="fallback-spinner vh-100">
        {/* <img
          className="fallback-logo"
          // style={{
          //   width: '188px',
          //   height: '40px'
          // }}
          src={logoIpague}
          alt="logo"
        /> */}
        <div className="loading">
          <div className="effect-1 effects"></div>
          <div className="effect-2 effects"></div>
          <div className="effect-3 effects"></div>
        </div>
      </div>
    );
  }
}

export default SpinnerComponent;
